import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function CTABanner() {
  return <section className="relative py-24 overflow-hidden bg-zinc-900 border-t border-zinc-200" data-id="element-29">
      <div className="absolute inset-0 opacity-20" data-id="element-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-peoplecall rounded-full filter blur-[120px]" data-id="element-31" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-peoplecall rounded-full filter blur-[120px]" data-id="element-32" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-33">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-34">
          <div className="mb-12 flex justify-center" data-id="element-35">
            <img src="https://cdn.magicpatterns.com/uploads/dimBe42JKH5ahc61F3HUTb/product.jpg" alt="Peoplecall Pod device with four microphones" className="w-full max-w-2xl h-auto rounded-2xl border border-zinc-700 shadow-2xl" data-id="element-36" />
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight" data-id="element-37">
            See Peoplecall Pod in action — in your space.
          </h2>
          <p className="text-xl text-zinc-300 mb-10 max-w-2xl mx-auto" data-id="element-38">
            Schedule a free, no-obligation demonstration. Our team will show you
            exactly how Peoplecall Pod would work in your facility and answer
            every question you have.
          </p>

          <Button size="lg" className="text-lg px-10 py-5 mb-6 shadow-[0_0_40px_rgba(229,64,0,0.5)]" data-id="element-39">
            Request Your Free Demo
          </Button>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-zinc-400 font-medium" data-id="element-40">
            <span data-id="element-41">Response within 24 hours</span>
            <span className="hidden sm:inline" data-id="element-42">•</span>
            <span data-id="element-43">No commitment</span>
            <span className="hidden sm:inline" data-id="element-44">•</span>
            <span data-id="element-45">Available worldwide</span>
          </div>
        </motion.div>
      </div>
    </section>;
}